module.exports = __webpack_public_path__ + "static/img/categories7.fbb6ab0.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/categories7.png
// module id = 3VbP
// module chunks = 1